/* Stockporter theme: cart drawer, quick add, kits, hero shelf, mobile CTA. */
(() => {
  const theme = (window.theme = window.theme || {});
  const routes = theme.routes || {};
  const base = (routes.root || '/').replace(/\/?$/, '/');
  const $ = (s, el = document) => el.querySelector(s);
  const reduced = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
  const esc = s => String(s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  theme.esc = esc;

  /* ---------------- toast ---------------- */
  let toastT;
  theme.toast = msg => {
    const t = document.getElementById('toast');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('show');
    clearTimeout(toastT);
    toastT = setTimeout(() => t.classList.remove('show'), 2200);
  };

  /* ---------------- money ---------------- */
  theme.money = cents => {
    const fmt = theme.moneyFormat || '${{amount}}';
    const whole = cents % 100 === 0;
    const amount = (cents / 100).toFixed(2);
    const withCommas = n => n.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      if (key === 'amount_no_decimals' || (key === 'amount' && whole)) return withCommas(String(Math.round(cents / 100)));
      if (key === 'amount_with_comma_separator') return amount.replace('.', ',');
      return withCommas(amount.split('.')[0]) + '.' + amount.split('.')[1];
    });
  };

  /* ---------------- label fitting (shared with studio.js) ---------------- */
  theme.fitLabels = root => {
    if (!root) return;
    root.querySelectorAll('.lab span').forEach(s => {
      s.style.fontSize = '';
      const box = s.parentElement;
      if (!box.clientWidth) return;
      const maxW = box.clientWidth * 0.86, maxH = box.clientHeight * 0.8;
      let fs = parseFloat(getComputedStyle(s).fontSize), guard = 0;
      while ((s.offsetWidth > maxW || s.offsetHeight > maxH) && fs > 5 && guard++ < 40) {
        fs *= 0.93;
        s.style.fontSize = fs + 'px';
      }
    });
  };

  /* ---------------- cart ---------------- */
  const drawer = () => document.getElementById('cart-drawer');
  async function refresh() {
    const [sRes, cRes] = await Promise.all([fetch(`${base}?sections=cart-drawer`), fetch(`${base}cart.js`)]);
    const sections = await sRes.json();
    const cart = await cRes.json();
    if (sections['cart-drawer']) {
      const doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
      const fresh = doc.querySelector('[data-cart-inner]');
      const cur = document.querySelector('#cart-drawer [data-cart-inner]');
      if (fresh && cur) cur.replaceWith(fresh);
    }
    document.querySelectorAll('[data-cart-count]').forEach(el => { el.textContent = cart.item_count; });
    const d = drawer();
    if (d && d.open) theme.fitLabels(d);
    return cart;
  }
  function fly(fromEl) {
    const target = $('[data-cart-open]');
    if (!fromEl || !target || reduced()) return;
    const a = fromEl.getBoundingClientRect(), b = target.getBoundingClientRect();
    const f = document.createElement('div');
    f.className = 'flyer';
    f.style.left = (a.left + a.width / 2 - 22) + 'px';
    f.style.top = (a.top + a.height / 2 - 9) + 'px';
    document.body.appendChild(f);
    const dx = (b.left + b.width / 2) - (a.left + a.width / 2), dy = (b.top + b.height / 2) - (a.top + a.height / 2);
    f.animate([{ transform: 'translate(0,0) rotate(-8deg) scale(1)' }, { transform: `translate(${dx}px,${dy}px) rotate(12deg) scale(.4)`, opacity: 0.5 }], { duration: 520, easing: 'cubic-bezier(.45,-0.25,.6,1)' }).onfinish = () => f.remove();
  }
  function open() {
    const d = drawer();
    if (!d) { location.href = routes.cart || `${base}cart`; return; }
    if (!d.open) d.showModal();
    theme.fitLabels(d);
  }
  async function add(items, fromEl, msg) {
    const res = await fetch(`${base}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items })
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) {
      theme.toast(data.description || data.message || 'That could not be added. Please try again.');
      throw new Error(data.description || 'add failed');
    }
    await refresh();
    fly(fromEl);
    theme.toast(msg || 'Added to cart');
    setTimeout(open, reduced() ? 0 : 480);
    return data;
  }
  async function change(key, quantity) {
    const res = await fetch(`${base}cart/change.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    });
    if (!res.ok) {
      const d = await res.json().catch(() => ({}));
      theme.toast(d.description || 'The cart could not be updated.');
    }
    if (document.querySelector('[data-cart-page]')) { location.reload(); return; }
    await refresh();
  }
  theme.cart = { add, change, refresh, open };

  document.addEventListener('click', e => {
    const d = drawer();
    if (e.target.closest('[data-cart-open]') && d) { e.preventDefault(); open(); return; }
    if (d && e.target === d) { d.close(); return; }
    if (e.target.closest('[data-cart-close]')) { if (d && d.open) d.close(); return; }
    const qtyBtn = e.target.closest('[data-line-qty]');
    if (qtyBtn) {
      const line = qtyBtn.closest('[data-line-key]');
      if (line) { e.preventDefault(); change(line.dataset.lineKey, Number(qtyBtn.dataset.lineQty)); }
      return;
    }
    const quick = e.target.closest('[data-quick-add]');
    if (quick) {
      e.preventDefault();
      add([{ id: Number(quick.dataset.quickAdd), quantity: 1 }], quick, `${quick.dataset.title || 'Item'} added`).catch(() => {});
      return;
    }
    const kit = e.target.closest('[data-kit-add]');
    if (kit) {
      e.preventDefault();
      let items = [];
      try { items = JSON.parse(kit.dataset.kitAdd); } catch (_) { items = []; }
      if (items.length) add(items, kit, `${kit.dataset.title || 'Kit'} added`).catch(() => {});
      return;
    }
    const copy = e.target.closest('[data-copy]');
    if (copy) {
      const src = document.getElementById(copy.dataset.copy);
      if (!src) return;
      const text = src.textContent.trim();
      const pick = () => {
        const r = document.createRange(); r.selectNodeContents(src);
        const sel = getSelection(); sel.removeAllRanges(); sel.addRange(r);
        theme.toast('Selected. Press Ctrl+C or Cmd+C');
      };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(text).then(() => theme.toast('Copied'), pick);
      else pick();
    }
  });

  /* ---------------- product gallery ---------------- */
  document.addEventListener('click', e => {
    const b = e.target.closest('[data-gallery-thumb]');
    if (!b) return;
    const gallery = b.closest('[data-gallery]');
    const main = gallery && gallery.querySelector('[data-gallery-main]');
    if (!main) return;
    main.src = b.dataset.src;
    main.srcset = b.dataset.srcset || '';
    main.alt = b.dataset.alt || '';
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(x => x.setAttribute('aria-current', String(x === b)));
  });

  /* ---------------- product form (non-label products) ---------------- */
  document.addEventListener('submit', e => {
    const form = e.target.closest('[data-product-form]');
    if (!form) return;
    e.preventDefault();
    const fd = new FormData(form);
    const id = Number(fd.get('id'));
    const quantity = Math.max(1, Number(fd.get('quantity') || 1));
    add([{ id, quantity }], form.querySelector('[type="submit"]'), `${form.dataset.title || 'Item'} added`).catch(() => {});
  });
  document.addEventListener('click', e => {
    const step = e.target.closest('[data-qty-step]');
    if (!step) return;
    const input = step.parentElement.querySelector('input[type="number"]');
    if (!input) return;
    const next = (Number(input.value) || 1) + Number(step.dataset.qtyStep);
    input.value = Math.min(Number(input.max) || 99, Math.max(Number(input.min) || 1, next));
  });
  document.addEventListener('change', e => {
    const auto = e.target.closest('[data-autosubmit]');
    if (auto && auto.form) { auto.form.submit(); return; }
    const sel = e.target.closest('[data-variant-select]');
    if (!sel) return;
    const form = sel.closest('form');
    const opt = sel.selectedOptions[0];
    const price = form && form.querySelector('[data-price]');
    if (price && opt && opt.dataset.price) price.textContent = opt.dataset.price;
    const btn = form && form.querySelector('[type="submit"]');
    if (btn && opt) {
      btn.disabled = opt.dataset.available !== 'true';
      btn.textContent = opt.dataset.available === 'true' ? 'Add to cart' : 'Sold out';
    }
  });

  /* ---------------- hero shelf ---------------- */
  const SHELF_Y = 330;
  const JARS = [
    { x: 38, w: 112, h: 232, fill: '#F3EEE2', pat: 'dust', pct: 0.66 },
    { x: 168, w: 100, h: 192, fill: '#EBC766', pat: 'penne', pct: 0.72 },
    { x: 286, w: 94, h: 250, fill: '#5A3A26', pat: 'beans', pct: 0.62 },
    { x: 398, w: 112, h: 172, fill: '#D9823B', pat: 'lentil', pct: 0.6 },
    { x: 528, w: 90, h: 142, fill: '#DBC49C', pat: 'oats', pct: 0.64 }
  ];
  function svgLabel(cx, cy, w, h, word, style) {
    const r = h * 0.2, x = cx - w / 2, y = cy - h / 2;
    const text = style === 'typewriter' ? word.toLowerCase() : word.toUpperCase();
    const ls = style === 'modern' ? 0.14 : style === 'noir' ? 0.18 : 0;
    const fam = style === 'typewriter' ? "'Courier Prime', monospace" : "'Jost', sans-serif";
    const wt = style === 'modern' ? 600 : style === 'noir' ? 500 : 700;
    let shape;
    if (style === 'noir') shape = `<rect x="${x}" y="${y}" width="${w}" height="${h}" rx="${r}" fill="#181818"/>`;
    else if (style === 'typewriter') shape = `<rect x="${x}" y="${y}" width="${w}" height="${h}" rx="${r}" fill="#FBF7EE" stroke="#141414" stroke-width="1.1"/><rect x="${x + 3}" y="${y + 3}" width="${w - 6}" height="${h - 6}" rx="${r - 2}" fill="none" stroke="#141414" stroke-width=".8"/>`;
    else shape = `<rect x="${x}" y="${y}" width="${w}" height="${h}" rx="${r}" fill="#fff" stroke="#D6D3CB" stroke-width="1"/>`;
    return `<g class="jl" data-w="${w * 0.8}" data-cx="${cx}">${shape}<text x="${cx + ls * 6}" y="${cy}" text-anchor="middle" dominant-baseline="central" font-family="${fam}" font-weight="${wt}" font-size="12" letter-spacing="${ls}em" fill="${style === 'noir' ? '#fff' : '#141414'}">${esc(text)}</text></g>`;
  }
  function fitSVG(svg) {
    svg.querySelectorAll('.jl').forEach(g => {
      const t = g.querySelector('text');
      const max = parseFloat(g.dataset.w), cx = parseFloat(g.dataset.cx);
      const ls = parseFloat(t.getAttribute('letter-spacing')) || 0;
      let fs = 12;
      t.setAttribute('font-size', fs);
      const len = t.getComputedTextLength();
      if (len > max) fs = Math.max(6, fs * max / len);
      t.setAttribute('font-size', fs.toFixed(2));
      t.setAttribute('x', (cx + ls * fs / 2).toFixed(2));
    });
  }
  function drawShelf(svg, words, style, popIndex) {
    let out = `<defs>
      <pattern id="p-dust" width="9" height="9" patternUnits="userSpaceOnUse"><circle cx="2" cy="3" r=".9" fill="#E0D8C4"/><circle cx="7" cy="7" r=".7" fill="#E8E1D0"/></pattern>
      <pattern id="p-penne" width="16" height="12" patternUnits="userSpaceOnUse"><rect x="1" y="2" width="11" height="4" rx="2" fill="#D6A844" transform="rotate(-24 6 4)"/><rect x="6" y="8" width="10" height="3.6" rx="1.8" fill="#E2B955" transform="rotate(18 11 10)"/></pattern>
      <pattern id="p-beans" width="12" height="10" patternUnits="userSpaceOnUse"><ellipse cx="4" cy="4" rx="3.6" ry="2.6" fill="#6E4630"/><path d="M1.5 4h5" stroke="#3E2618" stroke-width=".8"/><ellipse cx="10" cy="8.5" rx="3.2" ry="2.3" fill="#7A5038"/></pattern>
      <pattern id="p-lentil" width="7" height="7" patternUnits="userSpaceOnUse"><circle cx="2" cy="2" r="1.8" fill="#E39448"/><circle cx="5.5" cy="5.2" r="1.6" fill="#C9702C"/></pattern>
      <pattern id="p-oats" width="10" height="8" patternUnits="userSpaceOnUse"><ellipse cx="3" cy="3" rx="2.6" ry="1.5" fill="#C9AE7E"/><ellipse cx="8" cy="6.5" rx="2.2" ry="1.3" fill="#E6D3AE"/></pattern>
      <linearGradient id="oak" x1="0" x2="0" y1="0" y2="1"><stop offset="0" stop-color="#DDBA86"/><stop offset="1" stop-color="#C79D65"/></linearGradient>
    </defs>`;
    JARS.forEach((j, i) => {
      const top = SHELF_Y - j.h, bodyTop = top + 22, bodyH = j.h - 22;
      const fillTop = bodyTop + bodyH * (1 - j.pct);
      out += `<g>
        <ellipse cx="${j.x + j.w / 2}" cy="${SHELF_Y}" rx="${j.w / 2 + 6}" ry="5" fill="rgba(20,20,20,.12)"/>
        <clipPath id="jc${i}"><rect x="${j.x + 5}" y="${bodyTop + 5}" width="${j.w - 10}" height="${bodyH - 10}" rx="14"/></clipPath>
        <rect x="${j.x}" y="${bodyTop}" width="${j.w}" height="${bodyH}" rx="18" fill="#EEF3F2" fill-opacity=".6"/>
        <g clip-path="url(#jc${i})"><rect x="${j.x}" y="${fillTop}" width="${j.w}" height="${SHELF_Y - fillTop}" fill="${j.fill}"/><rect x="${j.x}" y="${fillTop}" width="${j.w}" height="${SHELF_Y - fillTop}" fill="url(#p-${j.pat})"/></g>
        <rect x="${j.x + 10}" y="${bodyTop + 16}" width="7" height="${bodyH - 44}" rx="3.5" fill="#fff" fill-opacity=".7"/>
        <rect x="${j.x}" y="${bodyTop}" width="${j.w}" height="${bodyH}" rx="18" fill="none" stroke="#9AA6A4" stroke-width="2.5"/>
        <rect x="${j.x - 4}" y="${top}" width="${j.w + 8}" height="26" rx="8" fill="url(#oak)" stroke="#B98E57" stroke-width="2"/>
        <path d="M${j.x + 4} ${top + 9}h${j.w} M${j.x + 4} ${top + 17}h${j.w}" stroke="#C49A62" stroke-width="1.2"/>
        <g data-jar="${i}">${svgLabel(j.x + j.w / 2, bodyTop + bodyH * 0.42, j.w * 0.82, 30, words[i] || '', style)}</g>
      </g>`;
    });
    out += `<rect x="4" y="${SHELF_Y}" width="632" height="20" rx="4" fill="url(#oak)"/>
      <rect x="4" y="${SHELF_Y + 14}" width="632" height="6" rx="3" fill="#B98E57"/>
      <path d="M84 ${SHELF_Y + 20}v26h8v-18h18v-8zM548 ${SHELF_Y + 20}v8h18v18h8v-26z" fill="#141414"/>`;
    svg.innerHTML = out;
    fitSVG(svg);
    if (popIndex != null && !reduced()) {
      const g = svg.querySelector(`[data-jar="${popIndex}"] .jl`);
      if (g) g.classList.add('pop');
    }
  }
  function initHero(hero) {
    const svg = hero.querySelector('[data-shelf]');
    if (!svg) return;
    let words;
    try { words = JSON.parse(svg.dataset.words || '[]'); } catch (_) { words = []; }
    const defaults = words.slice();
    let style = 'modern';
    drawShelf(svg, words, style);
    hero.querySelectorAll('[data-hero-style]').forEach(b => b.addEventListener('click', () => {
      style = b.dataset.heroStyle;
      hero.querySelectorAll('[data-hero-style]').forEach(x => x.setAttribute('aria-pressed', String(x === b)));
      drawShelf(svg, words, style);
      if (!reduced()) svg.querySelectorAll('.jl').forEach((g, i) => { g.style.animationDelay = (i * 60) + 'ms'; g.classList.add('pop'); });
    }));
    const input = hero.querySelector('[data-hero-word]');
    let t;
    if (input) input.addEventListener('input', () => {
      clearTimeout(t);
      t = setTimeout(() => {
        const v = input.value.replace(/[^\p{L}\p{N} &'-]/gu, '').trim().slice(0, 12);
        words[2] = v || defaults[2] || '';
        drawShelf(svg, words, style, 2);
      }, 160);
    });
    hero._redraw = () => drawShelf(svg, words, style);
  }
  const heroes = [...document.querySelectorAll('[data-hero]')];
  heroes.forEach(initHero);

  /* ---------------- sticky mobile CTA ---------------- */
  const mbar = document.getElementById('mbar');
  if (mbar && 'IntersectionObserver' in window) {
    const watched = [...document.querySelectorAll('[data-hero-cta], [data-studio]')];
    const visible = new Map();
    const io = new IntersectionObserver(entries => {
      entries.forEach(en => visible.set(en.target, en.isIntersecting));
      const anyVisible = [...visible.values()].some(Boolean);
      mbar.classList.toggle('show', !anyVisible && window.scrollY > 400);
    });
    watched.forEach(el => io.observe(el));
    if (!watched.length) {
      addEventListener('scroll', () => mbar.classList.toggle('show', window.scrollY > 600), { passive: true });
    }
  }

  /* ---------------- fonts & resize ---------------- */
  const fitAll = () => { theme.fitLabels(document); };
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => { heroes.forEach(h => h._redraw && h._redraw()); fitAll(); });
  let rt;
  addEventListener('resize', () => { clearTimeout(rt); rt = setTimeout(fitAll, 120); });
  fitAll();
})();
